import { ORANGE_COLORS } from '@junglescout/styles-library'

export const DEFAULT_APP_TYPE = 'default'

export const DEFAULT_THEME = {
  colors: ORANGE_COLORS
}
